module.exports = __webpack_public_path__ + "media/ai-video.b5aadfe6.mp4";